import { render, staticRenderFns } from "./CompanyObjectVisualizer.vue?vue&type=template&id=2438e038&scoped=true"
import script from "./CompanyObjectVisualizer.vue?vue&type=script&lang=js"
export * from "./CompanyObjectVisualizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438e038",
  null
  
)

export default component.exports